import { phoneNumber } from '#base/core/consts/companyData';
import type { CardType } from '#base/core/types/CardType';

const usps: CardType[] = [
	{
		icon: 'fa-hand-holding-medical',
		title: 'Innovatieve behandelmethoden',
		description:
            'We behandelen doelgericht met onder andere shockwave en dry needling voor snel en duurzaam resultaat.',
	},
	{
		icon: 'fa-calendar-days',
		title: 'Online afspraak inplannen',
		description:
            'Maak online een afspraak, zie direct onze beschikbaarheid en start snel met je herstel.',
	},
	{
		icon: 'fa-graduation-cap',
		title: 'Deskundige therapeuten',
		description:
            'Altijd geholpen door een ervaren fysiotherapeut die werkt met bewezen en effectieve methoden.',
	},
	{
		icon: 'fa-shield-heart',
		title: 'Fysiotherapie verzekerd',
		description:
            'Jouw zorgverzekeraar vergoed je behandeling wanneer je aanvullend verzekerd bent voor fysiotherapie.',
	},
	{
		icon: 'fa-comment-medical',
		title: 'Transparante communicatie',
		description:
            'Heldere uitleg, duidelijke doelen en altijd samen beslissen over jouw traject.',
	},
	{
		icon: 'fa-lightbulb',
		title: 'Snel hulp bij vragen',
		description:
            'Heb je ergens vragen over? Binnen 1 werkdag heb je een reactie ontvangen. Stuur een Whatsapp naar '
            + phoneNumber,
	},
];

export default usps;
